import * as api from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useWeldingSpecialists() {
  return useQuery({
    queryKey: queryKeys.user.weldingSpecialists(),
    queryFn: api.getWeldingSpecialists,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: "always",
  });
}
